<template>
  <svg
    id="circle-ctrl-right"
    xmlns="http://www.w3.org/2000/svg"
    width="10.006"
    height="10.006"
    viewBox="0 0 10.006 10.006"
  >
    <path
      id="Path_4622"
      data-name="Path 4622"
      d="M5,0a5,5,0,1,0,5,5A5,5,0,0,0,5,0ZM6.7,5.445,4.82,7.321a.625.625,0,1,1-.884-.884L5.369,5,3.935,3.569a.625.625,0,1,1,.884-.884L6.7,4.561A.625.625,0,0,1,6.7,5.445Z"
      fill="#00a1aa"
    />
  </svg>
</template>
